var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCharacter2Umbrella(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 301 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#363F66",
    d: "M171 272c23 0 41-6 41-15 0-8-18-14-41-14-22 0-41 6-41 14 0 9 19 15 41 15Z",
    opacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#C6A485",
    stroke: "#403649",
    strokeMiterlimit: 10,
    strokeWidth: 4.1,
    d: "M203 253c0-5-5-8-11-9-8-2-15 4-15 8 0 5 7 6 15 6 9 0 11 0 11-5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#6D5653",
    d: "M199 249c-1-2-3-3-5-3-3-1-7-1-11 1-3 2-4 5-3 6 0 0 4-3 9-3l10-1Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#EFD1B1",
    stroke: "#403649",
    strokeMiterlimit: 10,
    strokeWidth: 4.1,
    d: "M221 220c4 9-2 14-8 17-4 1-8 0-10-2s-5-9 2-14 14-5 16-1Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#876761",
    stroke: "#403649",
    strokeMiterlimit: 10,
    strokeWidth: 4,
    d: "M196 199c-2-1-5 1-6 4l-1 6 6 9 5 8s8 1 10-1c3-5 5-8 2-9l-8-8c-2-2-6-9-8-9Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#876761",
    d: "M133 242c-7 1-14 1-20-2-7-3-12-8-13-15-2-7 2-15 1-22 0-4-2-7-5-8s-6 3-7 7c-5 13-2 28 7 38s24 14 36 8l4-2c0-2 0-4-2-4h-1Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#403649",
    d: "M132 240c-7 1-14 0-20-3-5-3-9-7-10-13-1-7 2-14 1-21 0-3-1-6-3-8s-5-3-8-1c-5 3-7 10-7 16a36 36 0 0 0 27 42c6 1 13 1 19-1 3-1 7-3 7-7l-2-4h-3c-2-1-3 1-3 2s1 2 3 2h1c-1 0 0 0 0 0l-1 1c-2 2-5 2-7 3-5 1-11 0-15-1-10-4-18-12-21-22a37 37 0 0 1 1-24c1-1 2-4 4-4s3 3 4 5l-1 9c-1 6-2 12 1 18 2 6 7 10 13 13s14 3 21 2l2-3c-1-1-2-2-3-1Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#876761",
    d: "M164 258c-15 0-28-5-35-13-5-6-7-12-6-20 3-20 20-36 41-36 22 0 41 23 41 37 0 11-4 20-13 25-6 5-16 7-28 7Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#403649",
    d: "M164 191c21 0 39 23 39 35 0 23-18 30-39 30-22 0-41-11-39-30s17-35 39-35Zm0-4c-22 0-40 16-43 38-1 8 1 15 7 21 7 9 21 14 36 14 13 0 22-2 30-7 8-6 13-15 13-27 0-15-20-39-43-39Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#403649",
    d: "M126 217c-2 16 15 27 22 29 12 5 28 6 34 5l11-1c-7 4-19 6-29 6-22-1-40-7-41-27l3-12Z",
    opacity: 0.3
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#EFD1B1",
    stroke: "#403649",
    strokeMiterlimit: 10,
    strokeWidth: 4.1,
    d: "M166 260c0-5-5-8-11-9-8-2-15 3-15 8s7 6 15 6 11 0 11-5Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#876761",
    d: "m162 256-6-3c-3-1-6-1-11 1-3 2-4 5-3 6 0 0 5-3 9-3l11-1Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#EFD1B1",
    stroke: "#403649",
    strokeMiterlimit: 10,
    strokeWidth: 4.1,
    d: "M154 243c-3 9-12 8-18 6-3-1-6-5-6-8s3-9 11-8c9 1 14 6 13 10Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#876761",
    stroke: "#403649",
    strokeMiterlimit: 10,
    strokeWidth: 4,
    d: "M151 211c-2-3-5-3-8-2l-4 4-3 11-2 9s4 5 6 5c3 1 9-2 10-4 0-6 3-11 3-16l-2-7Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#DD516C",
    stroke: "#403649",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4,
    d: "M183 219c-17 2-34 2-50-4-4-1-8-1-10-4v-10l3-5c2-2 4-3 7-3h7c11 0 31 2 49 1 4-1 11-1 14 2 3 4 5 12 4 17-1 4 2 10 1 18l-1 3-2 1c-3 2-7 2-10 3v-3l-3-18-9 2Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#403649",
    d: "M192 220c1 0 0 0 0 0h1a128 128 0 0 1 7-1c3 0 6-2 8-4l1-7-2-2-2 2v2s0 1 0 0v2s-1 0 0 0h-1v1h-1v1c1-1 0 0 0 0h-1a17 17 0 0 1-3 1s-1 0 0 0h-4l-4 1c-1 0-2 1-1 2l2 2Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#876761",
    d: "M161 205c-20 0-36-4-47-12-13-9-20-24-20-43 0-46 25-73 67-73 18 0 43 6 56 23 10 13 10 33 10 50 0 21-2 34-11 43-9 8-25 12-55 12Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#403649",
    d: "M161 79c19 0 43 7 54 22 10 12 10 31 10 49 0 39-6 53-64 53-36 0-65-14-65-53s20-71 65-71Zm0-4c-22 0-40 8-52 22a83 83 0 0 0-17 53c0 37 25 57 69 57 31 0 47-4 57-13 9-9 11-23 11-44 0-18 0-38-11-52-13-17-39-23-57-23Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#403649",
    d: "M182 202c-39 6-96-1-84-71 0-2 2 24 13 39 18 24 47 28 47 28 9 3 24 4 24 4Z",
    opacity: 0.3
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#EFD1B1",
    d: "M200 132c-5-12-18-19-30-16-13 2-23 12-28 24-1 5-2 10-1 15 2 7 9 13 17 15l3 1c2 1 3 4 3 6 4 12 16 22 29 22 7 0 15 0 26-8 14-10 17-28 13-37-2-6-6-4-6-6 1-7 2-14 1-21-1-4-3-8-6-11-4-3-10-1-14 2-4 4-5 9-7 14Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#403649",
    d: "m200 132-1-2-5-6c-18-17-44-4-52 17-5 14 3 26 16 29l4 2 2 5c3 9 11 16 19 19 5 1 9 2 14 1 8 0 15-3 21-7 7-6 12-14 13-23 1-5 1-11-2-15l-3-2v-18c0-5-1-9-4-13-2-4-7-5-12-3-6 3-8 10-10 16Zm0 0c2-6 4-13 10-16 3-2 7-3 10-1 3 1 5 4 7 7l2 10-2 16h1c4 0 7 5 7 9 2 14-4 27-15 36-5 4-11 7-18 7-7 1-13 1-19-2-9-4-16-12-19-21-1-4-2-7-6-7-14-3-21-15-16-29 5-19 27-34 46-24 5 3 9 8 12 13v2Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#EFD1B1",
    d: "M104 159c1 6 2 17-4 17s-16-6-16-14c0-5 3-12 9-13 6-2 9 1 11 10Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#403649",
    d: "M104 159c0 6 3 19-7 18-6-2-12-5-14-11-2-5 0-11 4-15 2-4 7-6 12-3 2 1 3 4 4 6l1 5Zm0 0c-1-4-3-10-8-9l-4 1c-4 1-6 6-7 10-1 6 5 10 10 13l4 1h3c4-2 2-12 2-16Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#876761",
    d: "m97 158-3-1-3 2c-2 2-2 3-1 5l5 5h3l1-3-2-8Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#F2F2F2",
    d: "M72 100a10 10 0 1 0 0-21 10 10 0 0 0 0 21Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#403649",
    d: "M72 81a8 8 0 1 1 0 17 8 8 0 0 1 0-17Zm0-4a12 12 0 1 0 0 25 12 12 0 0 0 0-25Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#403649",
    d: "M81 90c0 5-2 8-9 8-8 1-10-11-8-8 5 7 15 3 13-7-1-4 4 2 4 7Z",
    opacity: 0.3
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#DD516C",
    d: "M94 126h-3c-7-3-7-16 0-39l-2 3-1 1c-7 0-7 0-9-2-3-2-2-8 4-16 10-16 16-27 31-33 7-3 15-4 22-4 11 0 20 3 26 5 17 4 51 20 47 38-3 14-24 19-51 26-19 5-40 10-57 19l-7 2Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#403649",
    d: "M136 38c11 0 20 3 26 4 19 6 48 22 45 37-4 21-66 22-107 43l-6 2h-2c-9-3-2-29 7-56L88 89l-8-1c-1-1-3-3 4-14 10-16 17-26 31-32 7-3 15-4 21-4Zm0-4c-8 0-15 1-22 4-16 7-23 18-33 33-2 4-9 15-4 20 3 2 4 2 10 2l-2 11c-1 9-3 21 5 24h4l8-2c17-9 38-14 56-19 28-7 50-12 53-27 2-9-4-18-16-26a118 118 0 0 0-59-20Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#403649",
    d: "M99 68c-9 27-15 52-7 56 3 1 7-1 8-2 41-21 117-28 109-43-3-7-7-11-32-9-14 2-45 12-73 17-15 3-3-22-8-13-7 11-17 10-17 10-1 5 3 5 9 5l11-21Z",
    opacity: 0.3
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#F2F2F2",
    d: "m96 145-2-1c-4 0-8-3-10-8-1-3-2-9 0-15l5-6c26-30 56-42 105-44h2c6 0 15 1 21 7 3 3 5 8 7 12 1 3 3 7 2 12 0 6-6 12-16 16l-37 10-72 16-5 1Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#403649",
    d: "M196 73c7 0 14 1 19 6 3 3 5 8 7 12 1 3 3 7 2 10 0 8-8 12-15 15l-36 10a184546 184546 0 0 1-79 16c-4 0-6-3-8-6-1-4-2-9 0-14l4-6c29-32 61-42 104-43h2Zm0-4h-2c-24 1-43 4-59 10-18 7-34 18-48 34v1l-4 6h-1c-3 6-1 13 1 17 2 5 6 8 10 9l3 1 6-1 36-8 35-9c13-2 25-5 37-10 11-4 17-10 18-17 1-5-1-9-2-13-2-4-4-9-8-13-7-6-16-7-22-7Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#403649",
    d: "M224 101c0 8-8 12-15 15l-37 10a184546 184546 0 0 1-78 16c-4 0-7-3-8-6-2-10-4-5 10-5l21-2 17-3c23-4 28-3 57-11l17-6 7-3 9-5Z",
    opacity: 0.3
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#403649",
    d: "M180 163c3 0 6-4 6-9s-3-9-6-9-5 4-5 9 2 9 5 9ZM219 154c1 0 3-3 3-7 0-3-2-6-3-6-2 0-3 3-3 6 0 4 1 7 3 7Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#EFB89C",
    d: "M182 175c4-1 6-3 6-5-1-2-4-3-7-2-4 0-6 3-6 5s3 3 7 2ZM226 161c3 0 5-2 4-3 0-2-2-2-5-1-3 0-5 2-4 3 0 2 3 2 5 1Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#403649",
    d: "M195 178h2l2 2 1 1c5 1 11-1 16-3l2-1c1 1 0 2-1 2-5 4-12 5-18 4-1 0-3 1-4-1l-1-3 1-1Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#EFD1B1",
    d: "M221 162c0 4-5 7-11 7-4 0-10 1-10-4s8-12 13-11c3 1 8 6 8 8Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#EFB89C",
    d: "M207 157c1-1 3-3 5-2l4 1 1 2-5 4-2 2c-2-3-8-4-11-4l-3 2h-2l1-1 2-3 8-2 2 1Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#403649",
    d: "M216 169c0-3 1-3 2-4l2-3-2-3-3-4c3 2 6 4 7 7 0 3-1 6-3 7h-3ZM206 170l-2 1c-2-1-4-2-4-5l3 2h1l2 1v1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCharacter2Umbrella);
export default __webpack_public_path__ + "static/media/character_2_umbrella.30a5e16e0f85ef02ba45dbcce36cc39b.svg";
export { ForwardRef as ReactComponent };